import { JobPost } from "@prisma/client";

export const getIsPaid = (jobPost: JobPost) => {
  return !!jobPost.paymentCreatedAt;
};
